import React from 'react';
import { Button } from '../ui/button';

export const AI_ADVISOR_PROMPT_CHIPS = [
  'What should I do next?',
  'Improve readiness',
  'Explain lender matches',
  'Prepare submission strategy',
  'Review pipeline risks',
  'Find commission risks',
];

const FundingAIAdvisorPromptChips = ({ onSelect, disabled }) => (
  <div className="flex flex-wrap gap-2">
    {AI_ADVISOR_PROMPT_CHIPS.map((prompt) => (
      <Button
        key={prompt}
        type="button"
        size="sm"
        variant="outline"
        className="rounded-xl"
        disabled={disabled}
        onClick={() => onSelect(prompt)}
      >
        {prompt}
      </Button>
    ))}
  </div>
);

export default FundingAIAdvisorPromptChips;
